import { createSelector } from '@ngrx/store';
import { Offer, OfferSource } from '@rd/types';
import { getOfferHubState, OfferHubState } from '../reducers/index';
import { OfferState } from '../reducers/offer.reducer';

const getOfferHubRootState = createSelector(
  getOfferHubState,
  (state: OfferHubState) => state.offer,
);

const getOfferMap = (state: OfferState) => state.offerMap;
const getOfferIds = (state: OfferState) => state.offerList.offerIds;
const getOfferLoading = (state: OfferState) => state.offerList.loading;
const getOfferDetailsLoading = (state: OfferState) =>
  state.offerDetails.loading;
const getOfferListError = (state: OfferState) => state.offerList.error;

export const getOfferHubOfferMap = createSelector(
  getOfferHubRootState,
  getOfferMap,
);

export const getOfferHubOfferIds = createSelector(
  getOfferHubRootState,
  getOfferIds,
);

export const getOfferList = createSelector(
  getOfferHubOfferMap,
  getOfferHubOfferIds,
  (offerMap: Record<string, Offer>, offerIds) => {
    return offerIds
      .map((id) => {
        return offerMap[id];
      })
      .filter((offer) => !!offer);
  },
);

export const getOfferListCount = createSelector(
  getOfferHubRootState,
  (state: OfferState) => {
    return state.offerList.count;
  },
);

export const getOfferListPageNumber = createSelector(
  getOfferHubRootState,
  (state: OfferState) => {
    return state.offerList.paginationOptions.page;
  },
);

export const getOfferListTotalPages = createSelector(
  getOfferHubRootState,
  (state: OfferState) => {
    return state.offerList.totalPageCount;
  },
);

export const getOfferListPaginationOptions = createSelector(
  getOfferHubState,
  (state: OfferHubState) => {
    return state.offer.offerList.paginationOptions;
  },
);

export const getOfferById = createSelector(
  getOfferHubOfferMap,
  (offerMap: Record<string, Offer>, props: { offerId: string }) => {
    return offerMap[props.offerId] || null;
  },
);

export const getOfferHubGetOfferLoading = createSelector(
  getOfferHubRootState,
  getOfferLoading,
);

export const getOfferHubGetOfferDetailsLoading = createSelector(
  getOfferHubRootState,
  getOfferDetailsLoading,
);

export const getOfferHubGetOfferError = createSelector(
  getOfferHubRootState,
  getOfferListError,
);

type OfferRenderState = 'loading' | 'error' | 'loaded' | 'empty';

export const getOfferRenderState = createSelector(
  getOfferHubGetOfferLoading,
  getOfferHubGetOfferError,
  getOfferHubOfferIds,
  (isLoading, offerListError, offerIds): OfferRenderState => {
    if (offerListError) {
      return 'error';
    }

    if (offerIds.length) {
      return 'loaded';
    }

    if (isLoading) {
      return 'loading';
    }

    // there are are 2 UI for empty state
    // - no data: api return empty array without any filters
    // - filter not match
    // we only implement filter not match UI for now
    return 'empty';
  },
);

export const getOffersBySource = (source: OfferSource) =>
  createSelector(getOfferList, (offers: Offer[]) =>
    offers.filter((offer) => offer.source === source),
  );
